import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "home-view" }
const _hoisted_2 = {
  key: 0,
  id: "home-view-default"
}
const _hoisted_3 = {
  key: 0,
  class: "position-relative",
  id: "category-filter-status"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "text-center me-3" }
const _hoisted_6 = { class: "fs-lg-8" }
const _hoisted_7 = { class: "ms-3 fw-bold" }
const _hoisted_8 = {
  key: 1,
  id: "pickup-sessions"
}
const _hoisted_9 = {
  key: 2,
  class: "mt-7 mb-5",
  id: "category-filter"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, "カテゴリで絞り込む", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 fs-lg-6 category-filter-description" }, "下記のタイムテーブルを選択したカテゴリでハイライトさせます。", -1)
const _hoisted_12 = { class: "mb-4 row row-cols-2 row-cols-lg-6 g-3" }
const _hoisted_13 = ["data-category"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "icon icon-me-2 icon-start icon-check" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 3,
  id: "session-timetable"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3 session-timetable-h2" }, "タイムテーブル", -1)
const _hoisted_20 = { class: "toc-anchor" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "mb-3 nav nav-tabs flex-nowrap" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "nav-items-small lh-1 d-md-none" }
const _hoisted_25 = { class: "event-days-items h-100 m-0 p-0 ps-3 pt-3 pb-3 d-flex flex-column justify-content-center align-items-stretch gap-3 font-weight-normal" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "fs-6 table table-striped table-bordered align-top" }
const _hoisted_28 = ["id"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "mb-3 text-center"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "py-7 text-center" }
const _hoisted_35 = { class: "charcter-large" }

import { ref, toRaw, computed } from 'vue';
  import SessionView from '@/components/SessionView.vue';
  import PickupSessionView from '@/components/PickupSessionView.vue';
  import RegisterButton from '@/components/RegisterButton.vue';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  props: {
    single: { type: Boolean },
    sessions: { type: Object },
    login: { type: Boolean },
    cart: { type: Object },
    entryList: { type: Object },
    seminar_session: { type: String },
    shareURL: { type: String },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String },
    eventHolding: { type: Boolean },
    eventAPIisAlive: { type: Boolean },
    getIndexOfItemFromObjectArray: {type: Function},
  },
  emits: ['addItem', 'removeItem', 'cancelItem', 'submitForm', 'openLink', 'openLinkWithNewWindow', 'openExternalLink', 'openExternalLinkWithNewWindow'],
  setup(__props, { emit: __emit }) {

  const props = __props;
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const emits = __emit;

  const addItem = (layout_id: string, reg_type='') => {
    emits('addItem', layout_id, reg_type);
  }

  const removeItem = (layout_id: string) => {
    emits('removeItem', layout_id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const submitForm = () => {
    emits('submitForm');
  }

  const openLink = (url: string) => {
    emits('openLink', url);
  }

  const openLinkWithNewWindow = (url: string) => {
    emits('openLinkWithNewWindow', url);
  }

  const openExternalLink = (url: string) => {
    emits('openExternalLink', url);
  }

  const openExternalLinkWithNewWindow = (url: string) => {
    emits('openExternalLinkWithNewWindow', url);
  }
  

  const categories = computed( // カテゴリのリスト
    () => {
      let temp = [];
      let tempCats = [];
      props.sessions.forEach((session) => {
      	if (!session || !session.categories || !session.categories.length) {
      		return tempCats;
      	}
        session.categories.forEach((category) => {
          if (category == null || !category || category.match(/^\s+$/)) {
            return;
          }
          temp.push(category);
        });
      });
      temp = Array.from(new Set(temp)); // ユニークにする
      temp.forEach((category) => {
        tempCats.push({ name: category, active: true });
      });
      return tempCats;
    }
  );

  const calendarTabs = computed( // 開催日のリスト
    () => {
      let temp = [];
      props.sessions.forEach((session) => {
        if (session.dateLabel) {
          temp.push(session.dateLabel);
        }
      });
      temp = Array.from(new Set(temp)); // ユニークにする
      temp.sort((a, b) => {
        return a > b;
      });
      return temp;
    }
  );

  const singleSession = computed( // 詳細ページのセッション
    () => {
      let temp = {};
      temp = props.sessions.find((session) => {
        return session.id === props.seminar_session;
      });
      temp = toRaw(temp);
      return temp;
    }
  );

  const ogImagesJSON = window.webtanOgImagesJSON;
  const ogimage = computed( // og:image
    () => {
      let temp = {};
      let url = '';
      if (props.single) {
        if ('undefined' != typeof(ogImagesJSON) && 'undefined' != typeof(ogImagesJSON.length) && ogImagesJSON.length) {
          temp = ogImagesJSON.find((item) => {
            return item.id === props.seminar_session;
          });
        }
      }
      if ('undefined' != typeof(temp) && 'undefined' != typeof(temp.url) && temp.url) {
        url = temp.url;
      }
      return url;
    }
  );

  const pickupSessionsJSON = window.webtanPickupSessionsJSON;
  const pickupSessions = computed( // 注目のセッション
    () => {
      let temp = [];
      if (!props.single) {
        if (
        	'undefined' != typeof(pickupSessionsJSON) &&
        	'undefined' != typeof(pickupSessionsJSON.length) &&
        	pickupSessionsJSON.length
        ) {
          pickupSessionsJSON.forEach((str) => {
            props.sessions.forEach((session) => {
              if (session.id === str) {
                temp.push(toRaw(session));
              }
            });
          });
        }
      }
      return temp;
    }
  );

  let timetable = computed( // タイムテーブル
    () => {
      let days = [];
      if (!props.single) {
        props.sessions.forEach((session) => {
          const day = days.find((day) => { return day.date === session.date });
          if (!day) {
            days.push({
              date: session.date,
              dateLabel: session.dateLabel,
              cols: 1,
              timebox: []
            });
          }
          days.find((day) => {
            if (day.date === session.date) {
              const time = session.timeStart + '-' + session.timeEnd;
              const timebox = day.timebox.find((timebox) => { return timebox.time === time });
              if (!timebox) {
                day.timebox.push({
                  time: time,
                  timeStart: session.timeStart,
                  timeEnd: session.timeEnd,
                  cols: 1,	// あとで再計算してる
                  sessions: []
                });
              }
              day.timebox.find((timebox) => {
                if (timebox.time === time) {
                  timebox.sessions.push(toRaw(session));
                }
              })
            }
          });
        });
        days.forEach((day) => { // カラム幅の計算
          day.timebox.forEach((timebox) => {
            timebox.cols = timebox.sessions.length;
            if (day.cols < timebox.cols) {
              day.cols = timebox.cols;
            }
          });
        });
      }
      return days;
    }
  );

  let isFiltered = ref(false);
  let filteredList = ref([]);
  let filteredListLabel = computed(
    () => {
      let temp = '';
      if (filteredList.value) {
        temp = filteredList.value.join(', ');
      }
      return temp;
    }
  );
  const toggleFilter = (i: number) => {
    if (isFiltered.value) {
      categories.value[i].active = !categories.value[i].active;
      const pos = filteredList.value.indexOf(categories.value[i].name);
      if (pos != -1) {
        filteredList.value.splice(pos, 1);
      } else {
        filteredList.value.push(categories.value[i].name);
      }
    } else {
      isFiltered.value = true;
      categories.value.forEach((category, index) => {
        categories.value[index].active = false;
      });
      categories.value[i].active = !categories.value[i].active;
      filteredList.value.push(categories.value[i].name);
    }
  }

  const toggleFilterAll = () => {
    isFiltered.value = false;
    filteredList.value = [];
    categories.value.forEach((category, index) => {
      categories.value[index].active = true;
    });
  }

  const isSlotWithoutSession = (session: object) => {
    return (session && session.regabel_status === '0' && session.dtlable_status == false);
  }

  const isFilteredSession = (session: object) => {
    if (isFiltered.value) {
      let flag = false;
      filteredList.value.forEach((listItem) => {
        if (
        	session &&
        	session.categories &&
        	session.categories.includes(listItem)
        ) {
          flag = true;
        }
      });
      return flag;
    } else {
      return false;
    }
  }

  const isCartInSession = (session: object) => {
    // console.log('session', session);
    if (session && session.layout_id) {
      if (
      	props.cart &&
      	-1 != props.getIndexOfItemFromObjectArray(
      		session.layout_id.toString(),
      		props.cart
      	)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const isEnrtySession = (session: object) => {
    if (session && session.layout_id) {
      if (
      	props.entryList &&
      	-1 != props.getIndexOfItemFromObjectArray(
      		session.layout_id.toString(),
      		props.entryList
      	)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.single)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!__props.login && categories.value && categories.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_unref(isFiltered))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["session-filter-fixed", _unref(isFiltered) ? 'bg-light py-2 px-3 position-fixed top-0 start-0' : '']),
                          style: {"z-index":"999"}
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilterAll())),
                                class: "text-nowrap btn btn-sm fw-bold btn-outline-primary fs-lg-8"
                              }, "クリア")
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createTextVNode("絞り込み:"),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(filteredListLabel)), 1)
                            ])
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(RegisterButton, {
            onSubmitForm: submitForm,
            login: __props.login,
            eventHolding: __props.eventHolding,
            cart: __props.cart,
            registerButtonSimple: false
          }, null, 8, ["login", "eventHolding", "cart"]),
          (!__props.login)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickupSessions.value, (session, p) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "my-4",
                    key: p
                  }, [
                    _createVNode(PickupSessionView, {
                      session: session,
                      onAddItem: addItem,
                      onRemoveItem: removeItem,
                      onCancelItem: cancelItem,
                      isFilteredSession: isFilteredSession(session),
                      isFiltered: _unref(isFiltered),
                      login: __props.login,
                      isCartInSession: isCartInSession(session),
                      isEnrtySession: isEnrtySession(session),
                      webinarMainLabel: __props.webinarMainLabel,
                      webinarSubLabel: __props.webinarSubLabel,
                      eventHolding: __props.eventHolding,
                      eventAPIisAlive: __props.eventAPIisAlive,
                      onOpenLinkWithNewWindow: openLinkWithNewWindow,
                      onOpenExternalLink: openExternalLink,
                      onOpenExternalLinkWithNewWindow: openExternalLinkWithNewWindow
                    }, null, 8, ["session", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!__props.login && categories.value && categories.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col",
                      key: i,
                      "data-category": category.name
                    }, [
                      (_unref(isFiltered))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: ($event: any) => (toggleFilter(i)),
                            class: _normalizeClass(["w-100 h-100 btn btn-sm fw-bold fs-lg-8", category.active ? 'btn-outline-primary' : 'btn-outline-secondary'])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(category.active ? 'icon icon-me-2 icon-start icon-check' : 'icon icon-me-2 icon-start icon-transparent')
                            }, _toDisplayString(category.name), 3)
                          ], 10, _hoisted_14))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: ($event: any) => (toggleFilter(i)),
                            class: "w-100 h-100 btn btn-sm fw-bold btn-outline-primary fs-lg-8"
                          }, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(category.name), 1)
                          ], 8, _hoisted_15))
                    ], 8, _hoisted_13))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleFilterAll())),
                    class: "btn btn-sm fw-bold btn-outline-primary fs-lg-8",
                    id: "button-category-filter-clear"
                  }, "絞り込みをクリア")
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(timetable))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timetable), (day, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-7",
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", {
                        id: day.dateLabel
                      }, null, 8, _hoisted_21)
                    ]),
                    _createElementVNode("ul", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarTabs.value, (tab, j) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["nav-item", day.dateLabel === tab ? 'fs-3 d-block' : 'fs-4 d-none d-md-block']),
                          key: j
                        }, [
                          _createElementVNode("a", {
                            href: '#' + tab,
                            class: _normalizeClass(["nav-link mb-0 d-flex justify-content-center align-items-center fw-bold text-decoration-none link-dark timetable-nav-link", day.dateLabel === tab ? 'active' : ''])
                          }, _toDisplayString(tab), 11, _hoisted_23)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", _hoisted_24, [
                        _createElementVNode("ul", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarTabs.value, (dayLink, k) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: k,
                              class: _normalizeClass([day.dateLabel === dayLink ? 'd-none' : 'd-block', "event-days-item lh-1"])
                            }, [
                              _createElementVNode("a", {
                                href: '#' + dayLink,
                                class: "text-decoration-none link-dark timetable-nav-link"
                              }, _toDisplayString(dayLink), 9, _hoisted_26)
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_27, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.timebox, (timebox, k) => {
                          return (_openBlock(), _createElementBlock("tr", { key: k }, [
                            _createElementVNode("th", {
                              class: "text-center text-nowrap fs-lg-6",
                              id: `${day.dateLabel}-${timebox.timeStart}-${timebox.timeEnd}`
                            }, [
                              _createTextVNode(_toDisplayString(timebox.timeStart), 1),
                              _hoisted_29,
                              _createTextVNode("～"),
                              _hoisted_30,
                              _createTextVNode(_toDisplayString(timebox.timeEnd), 1)
                            ], 8, _hoisted_28),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["mb-3 row row-cols-1 gx-0 gy-3 gx-lg-3", ['row-cols-lg-' + day.cols, 'sessions-max-cols-' + day.cols]])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timebox.sessions, (session, m) => {
                                  return (_openBlock(), _createBlock(SessionView, {
                                    key: m,
                                    session: session,
                                    track: m,
                                    onAddItem: addItem,
                                    onRemoveItem: removeItem,
                                    onCancelItem: cancelItem,
                                    isSlotWithoutSession: isSlotWithoutSession(session),
                                    isFilteredSession: isFilteredSession(session),
                                    isFiltered: _unref(isFiltered),
                                    login: __props.login,
                                    isCartInSession: isCartInSession(session),
                                    isEnrtySession: isEnrtySession(session),
                                    webinarMainLabel: __props.webinarMainLabel,
                                    webinarSubLabel: __props.webinarSubLabel,
                                    eventHolding: __props.eventHolding,
                                    eventAPIisAlive: __props.eventAPIisAlive,
                                    onOpenLinkWithNewWindow: openLinkWithNewWindow,
                                    onOpenExternalLink: openExternalLink,
                                    onOpenExternalLinkWithNewWindow: openExternalLinkWithNewWindow
                                  }, null, 8, ["session", "track", "isSlotWithoutSession", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive"]))
                                }), 128))
                              ], 2)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(RegisterButton, {
            onSubmitForm: submitForm,
            login: __props.login,
            eventHolding: __props.eventHolding,
            cart: __props.cart,
            registerButtonSimple: false
          }, null, 8, ["login", "eventHolding", "cart"])
        ]))
      : _createCommentVNode("", true),
    (__props.single)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          (ogimage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("img", {
                  src: ogimage.value,
                  class: "img-fluid rounded",
                  alt: ""
                }, null, 8, _hoisted_33)
              ]))
            : _createCommentVNode("", true),
          (singleSession.value)
            ? (_openBlock(), _createBlock(PickupSessionView, {
                key: 1,
                single: __props.single,
                session: singleSession.value,
                onAddItem: addItem,
                onRemoveItem: removeItem,
                onCancelItem: cancelItem,
                isFilteredSession: isFilteredSession(singleSession.value),
                isFiltered: _unref(isFiltered),
                login: __props.login,
                isCartInSession: isCartInSession(singleSession.value),
                isEnrtySession: isEnrtySession(singleSession.value),
                webinarMainLabel: __props.webinarMainLabel,
                webinarSubLabel: __props.webinarSubLabel,
                eventHolding: __props.eventHolding,
                eventAPIisAlive: __props.eventAPIisAlive,
                onOpenLinkWithNewWindow: openLinkWithNewWindow,
                onOpenExternalLink: openExternalLink,
                onOpenExternalLinkWithNewWindow: openExternalLinkWithNewWindow
              }, null, 8, ["single", "session", "isFilteredSession", "isFiltered", "login", "isCartInSession", "isEnrtySession", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, [
              _createElementVNode("button", {
                type: "button",
                class: "px-2 px-lg-5 btn btn-lg btn-accent2 fw-bold button-check-timetable",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openLink('/')))
              }, "他のタイムテーブルも見る")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})